import React from "react";
import FormularioCanjeTerceros from "js/components/CanjeTerceros";

function CanjeTerceros(props) {
  return <FormularioCanjeTerceros />;
}

export default CanjeTerceros;
